<donut-tabs class="m-tx4" :tabs="tabs" :initial-tab="initialTab" :can-select-tabs="false"></donut-tabs>